<template>
  <div
    class="hdawbtn icon_btn mdi csst csst_nm text-noselect"
    :class="value ? 'mdi-eye' : 'mdi-eye-off'"
    @click="$emit('click', !value)"
    @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
  >
    <div
      class="csst_content clr-white"
      v-html="value ? $t('tooltips.hide') : $t('tooltips.show')"
    />
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'

export default {
  name: 'HideShowBtn',
  mixins: [float_mix],
  props: {
    value: Boolean,
  },
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.hdawbtn {
  flex-shrink: 0;
  --after-height: 1.5rem;
  --after-width: 1.5rem;
}
</style>
